interface AboutInterface {
  title: string;
  description: string[];
  sections: AboutSection[];
}

interface AboutSection {
  title: string;
  description: string[];
}

export const aboutText: AboutInterface = {
  title: "BisnisLink: Platform Reseller untuk Promosi Produk UMKM",
  description: [
    "Bisnislink adalah platform yang menghubungkan UMKM (Usaha Mikro Kecil dan Menengah) sebagai Supplier dengan Reseller yang siap membantu memasarkan dan menjualkan produk-produk dari Supplier secara online. Platform ini dirancang untuk membantu UMKM menjangkau pelanggan yang lebih luas dan meningkatkan penjualan mereka, serta memberikan peluang bagi pemula memulai bisnis mereka sendiri secara online.",
    "Berikut beberapa hal yang perlu diketahui tentang BisnisLink:",
  ],
  sections: [
    {
      title: "Keuntungan bagi Supplier (UMKM)",
      description: [
        "Memperluas jangkauan pasar: BisnisLink membantu UMKM menjangkau pelanggan di seluruh Indonesia, tidak hanya di wilayah lokal mereka.",
        "Meningkatkan penjualan: Platform ini menyediakan berbagai fitur dan alat untuk membantu UMKM meningkatkan penjualan mereka, seperti promosi produk dan analitik penjualan.",
        "Menghemat waktu dan biaya: BisnisLink membantu UMKM menghemat waktu dan biaya dalam memasarkan dan menjual produk mereka secara online.",
      ],
    },
    {
      title: "Keuntungan bagi Reseller",
      description: [
        "Memulai bisnis dengan mudah: Reseller dapat memulai bisnis mereka sendiri dengan mudah di BisnisLink tanpa memerlukan modal yang besar.",
        "Akses ke berbagai produk: Reseller memiliki akses ke berbagai macam produk dari berbagai UMKM di berbagai kategori.",
        "Tambahan pendapatan: Reseller akan mendapat komisi dari setiap transaksi yang menggunakan link mereka.",
      ],
    },
    {
      title: "Keuntungan bagi Buyer",
      description: [
        "Transaksi aman: Bisnislink menjamin keamanan transaksi dengan sistem pembayaran terpercaya dan buyer dapat melacak status pesanan.",
        "Produk menarik dan terjangkau: Bisnislink menawarkan beragam produk dari UMKM yang unik dan menarik dengan harga yang kompetitif.",
        "Support produk UMKM: Buyer dapat membantu UMKM berkembang dengan membeli produk mereka di Bisnislink.",
      ],
    },
    {
      title: "Fitur-fitur menarik BisnisLink",
      description: [
        "Mudah untuk bergabung: Proses yang mudah untuk bergabung dengan Bisnislink baik kamu ingin menjadi Supplier, Reseller ataupun menjadi Buyer.",
        "Katalog produk: BisnisLink memiliki katalog produk yang luas dari berbagai UMKM di berbagai kategori dan dapat dibeli secara langsung.",
        "Alat analitik: Supplier, Reseller dan Buyer dapat melacak transaksi mereka dengan menggunakan alat analitik yang disediakan oleh BisnisLink.",
        "Sistem pembayaran yang aman: BisnisLink menyediakan sistem pembayaran yang aman dan terpercaya untuk semua transaksi.",
        "Laporan Transaksi: Setiap transaksi di Bisnislink tercatat dan dapat diakses oleh Supplier, Reseller dan juga oleh Buyer yang sudah melakukan transaksi",
      ],
    },
  ],
};

/**

BisnisLink: Platform Reseller untuk Promosi Produk UMKM 

Bisnislink adalah platform yang menghubungkan UMKM (Usaha Mikro Kecil dan Menengah) sebagai Supplier dengan Reseller yang siap membantu memasarkan dan menjualkan produk-produk dari Supplier secara online. Platform ini dirancang untuk membantu UMKM menjangkau pelanggan yang lebih luas dan meningkatkan penjualan mereka, serta memberikan peluang bagi pemula memulai bisnis mereka sendiri secara online.

Berikut beberapa hal yang perlu diketahui tentang BisnisLink:

Keuntungan bagi Supplier (UMKM):
Memperluas jangkauan pasar: BisnisLink membantu UMKM menjangkau pelanggan di seluruh Indonesia, tidak hanya di wilayah lokal mereka.
Meningkatkan penjualan: Platform ini menyediakan berbagai fitur dan alat untuk membantu UMKM meningkatkan penjualan mereka, seperti promosi produk dan analitik penjualan. 
Menghemat waktu dan biaya: BisnisLink membantu UMKM menghemat waktu dan biaya dalam memasarkan dan menjual produk mereka secara online.

Keuntungan bagi Reseller:
Memulai bisnis dengan mudah: Reseller dapat memulai bisnis mereka sendiri dengan mudah di BisnisLink tanpa memerlukan modal yang besar.
Akses ke berbagai produk: Reseller memiliki akses ke berbagai macam produk dari berbagai UMKM di berbagai kategori.
Tambahan pendapatan: Reseller akan mendapat komisi dari setiap transaksi yang menggunakan link mereka.

Keuntungan bagi Buyer:
Transaksi aman: Bisnislink menjamin keamanan transaksi dengan sistem pembayaran terpercaya dan buyer dapat melacak status pesanan.
Produk menarik dan terjangkau: Bisnislink menawarkan beragam produk dari UMKM yang unik dan menarik dengan harga yang kompetitif.
Support produk UMKM: Buyer dapat membantu UMKM berkembang dengan membeli produk mereka di Bisnislink.

Fitur-fitur menarik BisnisLink:
Mudah untuk bergabung: Proses yang mudah untuk bergabung dengan Bisnislink baik kamu ingin menjadi Supplier, Reseller ataupun menjadi Buyer.
Katalog produk: BisnisLink memiliki katalog produk yang luas dari berbagai UMKM di berbagai kategori dan dapat dibeli secara langsung.
Alat analitik: Supplier, Reseller dan Buyer dapat melacak transaksi mereka dengan menggunakan alat analitik yang disediakan oleh BisnisLink.
Sistem pembayaran yang aman: BisnisLink menyediakan sistem pembayaran yang aman dan terpercaya untuk semua transaksi.
Laporan Transaksi: Setiap transaksi di Bisnislink tercatat dan dapat diakses oleh Supplier, Reseller dan juga oleh Buyer yang sudah melakukan transaksi

 */
